import React from "react";
import t from "../../../../helpers/t";
import Biscuit from "../../../../../utils/Biscuit";

const NewContingentButtton = (props) => {
  const onButtonClicked = (e) => {
    props.onClicked(e);
  };
  const currentUrl = new URL(window.location.href);
  return (
    <>
      <a
        href={"contingents/add" + currentUrl.search}
        id="inb-c-left-bar-add-contingent"
        className={"button beautify beautify-" + Biscuit.get("user.client_id")}
      >
        <i className="fi fi-page-add"></i>
        <span>{t("add_${a}", { a: t("contingent", null, "capital") })}</span>
      </a>
    </>
  );
};
export default NewContingentButtton;
